import { render, staticRenderFns } from "./AutoSign.vue?vue&type=template&id=e4087942&scoped=true&"
import script from "./AutoSign.vue?vue&type=script&lang=js&"
export * from "./AutoSign.vue?vue&type=script&lang=js&"
import style0 from "./AutoSign.vue?vue&type=style&index=0&id=e4087942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4087942",
  null
  
)

export default component.exports